<template>
  <div v-for="(trucker, index) in randomCards" :key="index" class="channel">
    <div>
      <a :href="trucker.ytb_link" target="_blank" rel="noreferrer">
        <img
          :src="trucker.img"
          alt="youtube avatar"
          class="img w-24 h-24 my-1.5 mx-auto rounded-full outline-blue"
        />
        <h2
          v-text="trucker.name"
          class="mt-2.5 text-lg md:text-2xl transition duration-300 hover:text-gray-300"
        ></h2>
      </a>
      <p class="location text-gray-400" v-text="trucker.location"></p>
      <p
        class="desc py-5 px-3 whitespace-pre-wrap"
        :dir="trucker.desc_dir"
        v-text="trucker.desc"
      ></p>
    </div>
    <Social :socials="trucker.social" />
  </div>
</template>

<script>
import Social from "./Social.vue";
export default {
  data() {
    return {
      newTruckers: null,
    };
  },
  components: {
    Social,
  },
  props: ["randomCards"],

  mounted() {
    
  },
  updated(){
   
  }
};
</script>

<style>
.channel {
  width: 100%;
  transform: translateY(150px);
  opacity: 0;
  transition: all 0.5s;
}
.appear {
  opacity: 1;
  transform: translateY(0); 
}
.desc {
  font-family: "Cairo", Arial, sans-serif;
}
</style>